import produce from 'immer'
import {
  PRODUCT_GROUPS_LOAD,
  PRODUCT_GROUPS_LOAD_SUCCESS,
  PRODUCT_GROUPS_LOAD_FAIL
} from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {}
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case PRODUCT_GROUPS_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case PRODUCT_GROUPS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.productGroups
        return
      }
      case PRODUCT_GROUPS_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
